const singlePost = document.querySelector('body.single-post');
const preambleBlock = document.querySelector('section.post-preamble');
const postWarning = document.querySelector('.post-factbox.preamble-position');

if(singlePost && preambleBlock && postWarning) {
    const contentLeft = preambleBlock.querySelector('.content-left');
    const postAuthor = preambleBlock.querySelector('.content-left .post-author');

    if(postAuthor) {
        postAuthor.after(postWarning);
    }
    else if(contentLeft) {
        contentLeft.appendChild(postWarning);
    }
}